import { Component, inject, signal, PLATFORM_ID, OnInit } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { RouterOutlet } from '@angular/router';
import { Navbar } from './components/navbar/navbar';
import { Footer } from './components/footer/footer';
import { Sidebar } from './components/sidebar/sidebar';
import { Loading } from './components/loading/loading';
import { AsyncPipe } from '@angular/common';
import { AuthService } from './service/auth-service';
import { BehaviorSubject, map, combineLatest, timer } from 'rxjs';
import { distinctUntilChanged } from 'rxjs/operators';
import { Analytics, logEvent } from '@angular/fire/analytics';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, Navbar, Footer, Sidebar, Loading, AsyncPipe],
  templateUrl: './app.html',
  styleUrls: ['./app.scss'],
})
export class App implements OnInit {
  protected readonly title = signal('helageek');
  private authService = inject(AuthService);
  private platformId = inject(PLATFORM_ID);
  private analytics = inject(Analytics);
  private isBrowser = isPlatformBrowser(this.platformId);

  // First 5s loader
  private delayPassed$ = new BehaviorSubject(false);

  showLoading$ = combineLatest([
    this.authService.user$,
    this.delayPassed$,
  ]).pipe(
    map(([user, delayPassed]) => {
      if (!this.isBrowser) return true; // SSR → always show loader
      if (!delayPassed) return true;    // first 5s → show loader
      // After 5s → show only if user is undefined (Firebase still initializing)
      return user === undefined;
    }),
    distinctUntilChanged()
  );

  constructor() {

    if (this.isBrowser) {
      // Run delay timer only on browser
      timer(5000).subscribe(() => this.delayPassed$.next(true));
    }
  }

  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      logEvent(this.analytics, 'home_page_view', { page_path: '/' });
    }
  }
}
